import React from "react";
import { Link } from "react-router-dom";
import "../css/main.scss";
import productData from "../Datas/productData";

function Main() {
  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const categoryIcons = [
    { name: "Two-Stone Rings", product: productData[0] },
    { name: "Sculpted Bands", product: productData[2] },
    { name: "Marquise Details", product: productData[3] },
    { name: "Bracelets", product: productData[4] },
    { name: "Initial Pendants", product: productData[6] },
    { name: "Heart Necklaces", product: productData[7] },
    { name: "Accent Rings", product: productData[14] },
    { name: "Mismatched Studs", product: productData[12] },
  ];

  const bestSellers = productData.slice(0, 5);
  const collectionCards = [
    { label: "Color Stories", product: productData[5] },
    { label: "Modern Curves", product: productData[8] },
    { label: "Heart Details", product: productData[11] },
    { label: "Statement Bands", product: productData[18] },
  ];

  return (
    <main className="main">
      <section className="hero-section">
        <div className="hero-content">
          <div className="hero-badge">MAKE IT YOURS</div>
          <h1>Jewelry With a Personal Point of View</h1>
          <p>Choose the shape, color, and details that speak to you.</p>
          <Link to="/shop" className="hero-btn" onClick={toTop}>
            Explore the Collection
          </Link>
        </div>
      </section>

      <section className="trust-bar" aria-label="Shopping highlights">
        <div className="trust-item">✦ DISTINCTIVE DETAILS</div>
        <div className="trust-item">✦ MATERIAL OPTIONS</div>
        <div className="trust-item">✦ GIFT-WORTHY DESIGNS</div>
        <div className="trust-item">✦ ORDER SUPPORT</div>
      </section>

      <section className="categories-section" aria-labelledby="category-title">
        <div className="section-header centered">
          <div>
            <p className="eyebrow">Find your direction</p>
            <h2 id="category-title">Shop by design</h2>
          </div>
        </div>
        <div className="categories-grid">
          {categoryIcons.map((category) => (
            <Link
              to={`/shopDetails/${category.product.id}`}
              key={category.name}
              className="category-item"
              onClick={toTop}
            >
              <div className="category-icon">
                <img src={category.product.image} alt="" />
              </div>
              <span>{category.name}</span>
            </Link>
          ))}
        </div>
      </section>

      <section className="bestsellers-section" aria-labelledby="featured-title">
        <div className="section-header">
          <div>
            <p className="eyebrow">Selected for you</p>
            <h2 id="featured-title">Featured Jewelry</h2>
          </div>
          <Link to="/shop" className="shop-btn" onClick={toTop}>
            View all designs
          </Link>
        </div>

        <div className="products-grid">
          {bestSellers.map((product) => (
            <Link
              to={`/shopDetails/${product.id}`}
              key={product.id}
              className="product-card"
              onClick={toTop}
            >
              <div className="product-image">
                <img src={product.image} alt={product.name} />
              </div>
              <h3>{product.name}</h3>
              <div className="product-price">
                From <span className="price">€{product.price}</span>
              </div>
            </Link>
          ))}
        </div>
      </section>

      <section className="design-story">
        <div className="design-story-copy">
          <p className="eyebrow">Everyday details</p>
          <h2>Personal. Expressive. Easy to wear.</h2>
          <p>
            Build a collection around clean silhouettes, balanced color, and
            small details that hold meaning for you.
          </p>
          <Link to="/shop" className="light-btn" onClick={toTop}>
            Browse jewelry
          </Link>
        </div>
        <Link
          to={`/shopDetails/${productData[15].id}`}
          className="design-story-image"
          onClick={toTop}
        >
          <img src={productData[15].image} alt={productData[15].name} />
        </Link>
      </section>

      <section className="collections-section" aria-labelledby="collection-title">
        <div className="section-header centered">
          <div>
            <p className="eyebrow">A closer look</p>
            <h2 id="collection-title">Design stories</h2>
          </div>
        </div>
        <div className="collections-grid">
          {collectionCards.map(({ label, product }) => (
            <Link
              to={`/shopDetails/${product.id}`}
              className="collection-item"
              key={label}
              onClick={toTop}
            >
              <img src={product.image} alt={product.name} />
              <h3>{label}</h3>
            </Link>
          ))}
        </div>
      </section>

      <section className="engagement-section">
        <div className="engagement-center">
          <p className="eyebrow">Mark the moment</p>
          <h2>Rings for your next chapter</h2>
          <p>Explore silhouettes designed to celebrate a moment in your own way.</p>
          <Link to="/shop" className="engagement-btn" onClick={toTop}>
            Shop rings
          </Link>
        </div>
      </section>

      <section className="personalization-section">
        <div className="personalization-content">
          <div className="personalization-text">
            <p className="eyebrow">Thoughtful by design</p>
            <h2>A gift chosen with intention</h2>
            <p>
              Start with a shape, compare the available options, and review the
              details carefully before ordering.
            </p>
          </div>
          <Link
            to={`/shopDetails/${productData[6].id}`}
            className="personalization-image"
            onClick={toTop}
          >
            <img src={productData[6].image} alt={productData[6].name} />
          </Link>
        </div>
        <div className="personalization-steps">
          <div className="step"><div className="step-number">01</div><h3>Choose the mood</h3><p>Begin with a shape that suits the person and occasion.</p></div>
          <div className="step"><div className="step-number">02</div><h3>Compare options</h3><p>Review the listed size, finish, and stone choices.</p></div>
          <div className="step"><div className="step-number">03</div><h3>Check details</h3><p>Confirm every selection and spelling before ordering.</p></div>
          <div className="step"><div className="step-number">04</div><h3>Ask us</h3><p>Contact us if you need help choosing before checkout.</p></div>
        </div>
        <Link to="/shop" className="personalization-btn" onClick={toTop}>
          Shop personalized jewelry
        </Link>
      </section>

      <section className="checkout-note">
        <div>
          <p className="eyebrow">Before you order</p>
          <h2>Clear choices at checkout</h2>
          <p>Review the item, delivery details, and total before continuing.</p>
        </div>
        <div className="checkout-points" aria-label="Checkout steps">
          <span>Review your bag</span>
          <span>Confirm delivery</span>
          <span>Contact support</span>
        </div>
      </section>
    </main>
  );
}

export default Main;
